import {encodePart, orgBlockedUsersPath} from '@github-ui/paths'
import {fetchWithErrorHandling} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {useUpdateThreads} from '../stores/selectors'
import {produce} from 'immer'
import type {Thread} from '@github-ui/conversations'

export function useUnblockUserFromOrgMutation() {
  const updateThreads = useUpdateThreads()

  return useMutation({
    mutationFn: async ({organizationLogin, userLogin}: {organizationLogin: string; userLogin: string}) => {
      await fetchWithErrorHandling(`${orgBlockedUsersPath({owner: organizationLogin})}/${encodePart(userLogin)}`, {
        method: 'DELETE',
        redirect: 'manual', // We don't want to follow the redirect, we can update the comments directly
      })
    },
    onSuccess: (_data, variables) => {
      updateThreads(
        produce((oldThreads: Record<number, Thread>) => {
          // Find the comments of the unblocked user
          const unblockedUserComments = Object.values(oldThreads).flatMap(
            thread =>
              thread.commentsData?.comments.filter(comment => comment.author?.login === variables.userLogin) || [],
          )

          if (unblockedUserComments.length === 0) return

          for (const comment of unblockedUserComments) {
            comment.viewerCanBlockFromOrg = true
            comment.viewerCanUnblockFromOrg = false
          }
        }),
      )
    },
  })
}
